/* Плашка в колонке статуса строки (Figma Match Status 795:39593): радиус 8, точка; живые — заливка --live-bg, текст --live
   строчными (как «live», HQ-1899), прочие — ground. */
.badge { display: inline-flex; align-items: center; gap: 5px; max-width: 100%; padding: 3px 8px; border-radius: 8px;
  background: var(--ground); font-size: var(--fs-footnote); line-height: 1.231; font-weight: 500; }
.dot { width: 6px; height: 6px; flex: none; border-radius: 50%; }
.label { min-width: 0; overflow-wrap: anywhere; }
.live { background: var(--live-bg); color: var(--live); text-transform: lowercase; }
.live .dot { background: var(--live); }
.break { color: var(--content-primary); }
.break .dot { background: #FFC700; }
.rain { color: var(--content-primary); }
.rain .dot { background: #0A84FF; }
.neutral { color: var(--content-secondary); }
